<div class="header-wrapper px-2">
    <div class="header">
        <div class="header-back" *ngIf="routeData">
            <div class="title-bar ms-4 d-flex align-items-center">
                <mat-icon
                    class="title-bar-icon"
                    [svgIcon]="routeData.useFontIcon ? '' : routeData.icon"
                    [fontIcon]="routeData.useFontIcon ? routeData.icon : ''"
                ></mat-icon>
                <div class="d-flex flex-column px-2">
                    <h5 class="title-bar-title" *ngIf="routeData?.title">{{ routeData.title }}</h5>
                    <span class="title-bar-sub-title" *ngIf="routeData?.subTitle">{{ routeData.subTitle }}</span>
                </div>
            </div>
        </div>
        <div class="header-right me-4">
            <mat-icon class="header-icon">notifications_none</mat-icon>
            <div class="cursor-pointer user-avatar" [matMenuTriggerFor]="menu">
                <img src="./assets/user-avatar.png" />
            </div>
            <mat-menu #menu="matMenu" class="topheadermenu">
                <div class="nym-dropdown">
                    <div class="nym-dropdown-content">
                        <div class="nym-dropdown-item" (click)="logout()">Log out</div>
                    </div>
                </div>
            </mat-menu>
        </div>
    </div>
</div>
